
import { ExodusResources } from './exodus.resource';

export const GroupTemplateUrl = {
    GROUP_TEMPLATE: ExodusResources.GROUPTEMPLATE,
    GROUP_TEMPLATES_GET: ExodusResources.GROUPTEMPLATE + '/{0}',
    GROUP_TEMPLATE_ADD: ExodusResources.GROUPTEMPLATE,
    GROUP_TEMPLATE_UPDATE: ExodusResources.GROUPTEMPLATE + '/{0}',
    GROUP_TEMPLATE_REMOVE: ExodusResources.GROUPTEMPLATE + '/{0}',
    GROUP_TEMPLATE_ATTACHMENT_GET : ExodusResources.GROUPTEMPLATE + '/{0}/attachments',
    GROUP_TEMPLATE_ATTACHMENT_UPLOAD : ExodusResources.GROUPTEMPLATE + '/{0}/attachments',
    GROUP_TEMPLATE_ATTACHMENT_REMOVE : ExodusResources.GROUPTEMPLATE + '/{0}/attachments/{1}',
    GROUP_TEMPLATE_AUDIT_TRAIL : ExodusResources.GROUPTEMPLATE + '/{0}/audittrail',
    GET_DOWN_LIST_COUNTRY : ExodusResources.GROUPTEMPLATE + '/countries/dropdown-list',
    GET_CENTRE: ExodusResources.GROUPTEMPLATE + '/centre'
};


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/urls/group-template.url.ts